import { startWith } from 'rxjs/operators';
import {Component, Input, OnInit} from '@angular/core';
import {AbstractControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {EformService} from "../../../service/eform.service";

@Component({
   selector: 'app-number',
   templateUrl: './number.component.html',
   styleUrls: ['./number.component.css']
})
export class NumberComponent implements OnInit {
   @Input() field: any = {};
   @Input() form: FormGroup;
   @Input() checkValidate: any;
   @Input() fieldName: any;
   @Input() placeholder: any;
   @Input() labelName: any;
   @Input() hideHeader: boolean = false;
   decimal: any;
   number: any;
   rangeStart: any;
   rangeEnd: any;
   value: any;
   maxlength = 15;
   showError = true;
   pasteError = false;

   constructor(private eformService: EformService) {
   }

   ngOnInit(): void {
      this.value = this.eformService.eForm.value.value && this.eformService.eForm.value.value[this.fieldName] ? this.eformService.eForm.value.value[this.fieldName] : this.value;
      this.rangeStart = this.field.rangeStart.toString().replace(/,/g, '');
      this.rangeEnd = this.field.rangeEnd.toString().replace(/,/g, '');
      if (this.field.required && this.field.rangeStart !== '' && this.field.rangeEnd !== '') {
         this.form.controls[this.fieldName].setValidators([Validators.required, this.range(Number(this.rangeStart), Number(this.rangeEnd))]);
      } else if (this.field.rangeStart !== '' && this.field.rangeEnd !== '') {
         this.form.controls[this.fieldName].setValidators([this.range(Number(this.rangeStart), Number(this.rangeEnd))]);
      } else if (this.field.rangeStart === '' && this.field.rangeEnd === '') {
         this.form.controls[this.fieldName].setValidators([this.range(Number(this.rangeStart), Number(this.rangeEnd))]);
      }
   }

   range(min: number, max: number): ValidatorFn {
      return (c: AbstractControl): { [key: string]: boolean } | null => {
         if (!c.value) {
            return null;
         }
         let value = c.value.toString().replace('%', '');
         value = value.replace(/\s/g, '');
         value = value.replace(/,/g, '');
         if (value === '-') {
            return {'isDash': true};
         }
         if (value === '.') {
            return {'isDot': true};
         }
         if (isNaN(value) || value.length >= this.maxlength) {
            return {'allInvalid': true};
         }
         if (this.field.decimalPlace > 0) {
            value = Number(value).toFixed(this.field.decimalPlace);
         }
         min = min === 0 ? -Infinity : min;
         max = max === 0 ? Infinity : max;
         if (value && (isNaN(value) || value < min || value > max)) {
            return {'range': true};
         }
         return null;
      };
   }

   onChange(event) {
      let value = event.value.replace('%', '');
      let splNumber, splDecimal;
      value = value.replace(/\s/g, '');
      value = value.replace(/,/g, '');
      value = value !== '' && Number(value) === 0 ? '0' : value;
      if (value !== '0') {
         value = value.replace(/^0+(?=[1-9])/g, '');
         value = value.replace(/^-?0+(?=[1-9])/g, '-');
      }
      this.changeDecimalPlace(this.field.decimalPlace);
      if (isNaN(value) || event.value.indexOf('.') === -1) {
         this.number = Number(Math.round((parseFloat(value) + Number.EPSILON) * this.decimal) / this.decimal).toFixed(this.field.decimalPlace);
         if (isNaN(this.number)){
            this.number = value;
         } else {
            this.number = String(this.number).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
         }
      } else {
         this.number = Number(Math.round((parseFloat(value) + Number.EPSILON) * this.decimal) / this.decimal).toFixed(this.field.decimalPlace);
         if (isNaN(this.number)) {
            this.number = value;
         } else {
            if (this.field.decimalPlace > 0) {
               splNumber = this.number.toString().split('.')[0];
               splDecimal = '.' + this.number.toString().split('.')[1];
            } else {
               splNumber = this.number;
               splDecimal = '';
            }
            this.number = splNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + splDecimal;
         }
      }
      if (this.field.type === 'percent') {
         this.form.controls[this.fieldName].setValue(this.number + ' %');
      } else {
         this.form.controls[this.fieldName].setValue(this.number);
      }
   }

   changeDecimalPlace(decimal) {
      switch (decimal) {
         case 1: {
            this.decimal = 10;
            break;
         }
         case 2: {
            this.decimal = 100;
            break;
         }
         case 3: {
            this.decimal = 1000;
            break;
         }
         case 4: {
            this.decimal = 10000;
            break;
         }
         case 5: {
            this.decimal = 100000;
            break;
         }
         default: {
            this.decimal = 1;
            break;
         }
      }
   }

   editNumPercent(event) {
      this.showError = true;
      let value = event.value;
      if (this.field.type === 'percent') {
         value = value.replace(' %', '');
         value = value.replace(/\s/g, '');
         value = value.replace(/,/g, '');
         this.form.controls[this.fieldName].setValue(value);
      } else {
         value = value.replace(/\s/g, '');
         value = value.replace(/,/g, '');
         this.form.controls[this.fieldName].setValue(value);
      }
   }

   checkPercent(event) {
      if (!this.pasteError) {
         return;
      }
      this.showError = true;
      if (this.field.type === 'percent') {
         let value = event.value.replace(' %', '');
         value = value !== '' && Number(value) === 0 ? '0' : value;
         if (value !== '0') {
            value = value.replace(/^0+(?=[1-9])/g, '');
            value = value.replace(/^-?0+(?=[1-9])/g, '-');
         }
         if (!event.value) {
            this.form.controls[this.fieldName].setValue('');
         } else {
            this.onChange(event);
         }
      } else {
         this.onChange(event);
      }
      event.blur();
   }

   onPaste(event): void {
      const regex = /^-?\d{0,3}(,\d{3})*\.?(\d+)?$/;
      const pastedText = event.clipboardData?.getData('text') || '';
      this.pasteError = regex.test(pastedText);
   }

   onInput(event): void {
      const regex = /^-?\d{0,3}(,\d{3})*\.?(\d+)?$/;
      const val = event.target.value;
      this.pasteError = regex.test(val);
   }

   isEmpty(value: any): boolean {
      return value == null || value === '';
   }

   disableRightClick(event) {
      event.preventDefault();
   }

}
